<script>
  import { onMount } from "svelte";
  import { getTime } from "../utils/utils";
  export let done;
  export let pause;
  let timer;
  let totalTime = 0;

  onMount(() => {
    timer = setInterval(() => {
      if (!pause) {
        totalTime++;
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  });

  $: {
    if (done) {
      clearInterval(timer);
      timer = null;
    }
  }

  $: totalTimeName = getTime(totalTime);
</script>

<h3>
  Total Time
  <span
    class="block text-2xl md:text-4xl 2xl:text-7xl text-shadow-lg font-semibold text-green-300 whitespace-pre-wrap font-mono"
  >
    {totalTimeName}
  </span>
</h3>
